import React from 'react';
import { useLocation } from 'react-router-dom';

import { componentService } from 'js/services/component.service';

import style from './ShowUrl.scss';

/**
 * Use this component ONLY for debug purposes.
 */
export const ShowUrl = () => {
    const location = useLocation();
    const { pathname, search, hash } = location;

    return (
        <div className={style.showUrl}>
            <span>{pathname + search + hash}</span>
        </div>
    );
};

componentService.registerWebContentComponents({ ShowUrl });
